
'use client';
import { useState, useEffect } from 'react'; // Import useEffect
import Image from 'next/image';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';
import { AiFillFacebook } from 'react-icons/ai';
import { RiTwitterXFill } from 'react-icons/ri';
import { CiLink } from 'react-icons/ci';
import { MdEmail } from 'react-icons/md';
import { ImVk } from 'react-icons/im';
import { FaLinkedin, FaRedditAlien, FaSquarePinterest } from 'react-icons/fa6';
import Modal from 'react-modal';
import ShippingDialog from '@/components/products/ShippingDialog';
import ReturnDialog from '@/components/products/ReturnDialog';
import SafeDialog from '@/components/products/SafeDialog';
import SuggestionsProducts from '@/components/products/SuggestionProducts';
import Newshop from '../home-page/body/shopLetterOtherPages';
import { useTranslations } from 'next-intl';
import { useLocale } from 'next-intl';
import parse from 'html-react-parser';
import SizeMeasurment from './sizemeasurments';
import { useCart } from '../cart';
import { Link } from '@/i18n/routing';
import { Gallery, Item } from "react-photoswipe-gallery";
import "photoswipe/dist/photoswipe.css";
import useFetchReviews from '../user-dashboard/FetcherReviews';
import DoubleAccordion from './ProductAccording';
import Offer from '../home-page/body/offer';
import { FaTelegramPlane } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { MdCopyAll } from "react-icons/md";
import { useSession } from "next-auth/react";
import {
  FacebookShareButton,
  PinterestShareButton,
  RedditShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  VKShareButton,
  EmailShareButton
} from 'next-share'


import AddReview from '../admin-dashboard/addRviews';


// Set the root element for accessibility (required by react-modal)
if (typeof window !== 'undefined') {
  Modal.setAppElement(document.body);
}

export default function ProductId(pro: any) {
  const [num, setNum] = useState<number>(1);
  const [color, setColor] = useState<any[]>([]); // State to store fetched color data
  const [loading, setLoading] = useState<boolean>(true); // State to handle loading
  const [error, setError] = useState<string | null>(null); // State to handle errors
  const [size, setSize] = useState<any[]>([]); // State to store fetched color data
  const [selectcolor, setSelectColor] = useState<any>(null);
  const [selectsize, setSelectsize] = useState<string | null>(null);
  const [view, setView] = useState<Boolean>(false);
  const { cart, addItemToCart } = useCart();
  
  const [isCopied, setIsCopied] = useState(false); // Track if password is copied

  const { reviews} = useFetchReviews();
  const { data: session } = useSession();
  
  const t = useTranslations('Shop-id');
  const neo = pro;
  const idcs = neo.pro.id;
const proid = idcs+selectcolor+selectsize
  const l = useLocale();


const getLocalizedField = (item: any, field: string) => item[`${field}_${l}`] || item[`${field}_en`];

  const handleCopyurl = () => {
    
    navigator.clipboard.writeText(`${process.env.NEXT_PUBLIC_HOME}/${l}/blog/${getLocalizedField(neo.pro, "url")}`)
      .then(() => {
        setIsCopied(true); // Show "Copied!" text
        setTimeout(() => setIsCopied(false), 2000); // Hide "Copied!" text after 2 seconds
      })
   
};


const social = () => {
  return (
    <div className="flex gap-3 text-secondary flex-wrap">
       <FacebookShareButton url={`${process.env.NEXT_PUBLIC_HOME}/${l}/product/${getLocalizedField(neo.pro, "url")}`}><AiFillFacebook size={24} className="hover:text-[#1877F2]"/></FacebookShareButton>
        <TwitterShareButton url={`${process.env.NEXT_PUBLIC_HOME}/${l}/product/${getLocalizedField(neo.pro, "url")}`}><RiTwitterXFill size={24} className="hover:text-gray-600"/></TwitterShareButton>
       <RedditShareButton url={`${process.env.NEXT_PUBLIC_HOME}/${l}/product/${getLocalizedField(neo.pro, "url")}`}> <FaRedditAlien size={24} className="hover:text-[#FF4500]"/></RedditShareButton>
       <TelegramShareButton url={`${process.env.NEXT_PUBLIC_HOME}/${l}/product/${getLocalizedField(neo.pro, "url")}`}> <FaTelegramPlane size={24} className="hover:text-blue-500"/></TelegramShareButton>
       <WhatsappShareButton url={`${process.env.NEXT_PUBLIC_HOME}/${l}/product/${getLocalizedField(neo.pro, "url")}`}><FaWhatsapp size={24} className="hover:text-[#25D366]"/></WhatsappShareButton>
        <PinterestShareButton url={`${process.env.NEXT_PUBLIC_HOME}/${l}/product/${getLocalizedField(neo.pro, "url")}`} media={getLocalizedField(neo.pro, "description")}><FaSquarePinterest size={24} className="hover:text-[#E60023]"/></PinterestShareButton>
         <LinkedinShareButton url={`${process.env.NEXT_PUBLIC_HOME}/${l}/product/${getLocalizedField(neo.pro, "url")}`}><FaLinkedin size={24} className="hover:text-[#0077B5]"/></LinkedinShareButton>
        <VKShareButton url={`${process.env.NEXT_PUBLIC_HOME}/${l}/product/${getLocalizedField(neo.pro, "url")}`}> <ImVk size={24} className="hover:text-[#0077FF]"/></VKShareButton>
         <EmailShareButton url={`${process.env.NEXT_PUBLIC_HOME}/${l}/product/${getLocalizedField(neo.pro, "url")}`}><MdEmail size={24} className="hover:text-gray-600 "/></EmailShareButton>
       {isCopied? <MdCopyAll size={24} className="text-green-500"/> : <CiLink size={24} onClick={handleCopyurl} className="hover:text-green-500"/>}
    </div>
  )
}




  const productReviews = reviews.filter(post => post.product === idcs);
//console.log(productReviews)
  // Fetch color data using useEffect
  useEffect(() => {
    const fetchColor = async () => {
      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_URL}productimagevariation/?product=${idcs}`,
          {
            headers: {
              Authorization: `Token ${process.env.NEXT_PUBLIC_TOKEN}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch color data');
        }

        const data = await response.json();
        
        setColor(Array.isArray(data) ? data : []); // Set the first item from the response
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    fetchColor();
  }, [idcs]); // Re-run effect when `idcs` changes

  

  useEffect(() => {
    const fetchSize = async () => {
      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_URL}productsizevariation/?product=${idcs}`,
          {
            headers: {
              Authorization: `Token ${process.env.NEXT_PUBLIC_TOKEN}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch color data');
        }

        const data = await response.json();
        setSize(Array.isArray(data) ? data : []); // Set the first item from the response
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    fetchSize();
  }, [idcs]); // Re-run effect when `idcs` changes


  


  const reduction = (old: any, new_p: any) => {
    if (old === null || old === 0) return 0; // Handle null or zero old_price
    return ~~(((old - new_p) / old) * 100);
  };

  const Plus = () => {
    setNum(num + 1);
  };

  const Minus = () => {
    if (num > 1) {
      setNum(num - 1);
    }
  };

 
const add = () => {
  addItemToCart({id:proid,  
    price:+neo.pro.new_price, 
    quantity:num, 
    size: selectsize,
    color:selectcolor,
    name_en: neo.pro.title_en,
    name_ar: neo.pro.title_ar,
    name_fr: neo.pro.title_fr,
 name_de: neo.pro.title_de,
 name_es: neo.pro.title_es,
 name_it: neo.pro.title_it,
 name_pt: neo.pro.title_pt,
 name_nl: neo.pro.title_nl,
 name_ru: neo.pro.title_ru,
 name_sv: neo.pro.title_sv,
 image_en: neo.pro.image_en,
 image_ar: neo.pro.image_ar,
 image_fr: neo.pro.image_fr,
 image_de: neo.pro.image_de,
 image_es: neo.pro.image_es,
 image_it: neo.pro.image_it,
 image_pt: neo.pro.image_pt,
 image_nl: neo.pro.image_nl,
 image_ru: neo.pro.image_ru,
 image_sv: neo.pro.image_sv,
 tag_en: neo.pro.tag_en,
 tag_ar: neo.pro.tag_ar,
 tag_fr: neo.pro.tag_fr,
 tag_de: neo.pro.tag_de,
 tag_es: neo.pro.tag_es,
 tag_it: neo.pro.tag_it,
 tag_pt: neo.pro.tag_pt,
 tag_nl: neo.pro.tag_nl,
 tag_ru: neo.pro.tag_ru,
 tag_sv: neo.pro.tag_sv,
 url_en: neo.pro.url_en,
 url_ar: neo.pro.url_ar,
 url_fr: neo.pro.url_fr,
 url_de: neo.pro.url_de,
 url_es: neo.pro.url_es,
 url_it: neo.pro.url_it,
 url_pt: neo.pro.url_pt,
 url_nl: neo.pro.url_nl,
 url_ru: neo.pro.url_ru,
 url_sv: neo.pro.url_sv,
 productID:neo.pro.id,
 dropshippingID:neo.pro.dropshippingID,
 originalPrice:+neo.pro.new_price,
 discounte:0
  })
  setView(true)
}
 


  // Handle loading and error states
  if (loading) {
    return <div><SkeletonLoader/></div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }




  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 custom:mx-52">
    

        <div className="col-span-1 ">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1  gap-1">
           <Gallery>
      <Item
        original={`${process.env.NEXT_PUBLIC_IMAGE}/${getLocalizedField(neo.pro, 'image')}` || ''}

        width="2000"
        height="2000"
        alt={getLocalizedField(neo.pro, 'tag') || ''}
      >
        {({ ref, open }) => (
          <Image
            ref={ref}
            onClick={open}
            height={800}
            width={800}
            src={`${process.env.NEXT_PUBLIC_IMAGE}/${getLocalizedField(neo.pro, 'image')}` || ''}
            alt={getLocalizedField(neo.pro, 'tag') || ''}
            priority
          />
        )}
      </Item>
         {getLocalizedField(neo.pro, 'image1') !== null ? 
      <Item
        original={`${process.env.NEXT_PUBLIC_IMAGE}/${getLocalizedField(neo.pro, 'image1')}` || ''}

        width="2000"
        height="2000"
        alt={getLocalizedField(neo.pro, 'tag1') || ''}
      >
        {({ ref, open }) => (
          <Image
            ref={ref}
            onClick={open}
            height={800}
            width={800}
             src={`${process.env.NEXT_PUBLIC_IMAGE}/${getLocalizedField(neo.pro, 'image1')}` || ''}
            alt={getLocalizedField(neo.pro, 'tag') || ''}
            priority
          />
        )}
      </Item>
      :""}
    </Gallery>
           
          </div>
        </div>

        <div className="col-span-1 space-y-5 px-5 md:px-10 pb-4">
          <h1 className="font-semibold text-3xl mt-8">{getLocalizedField(neo.pro, 'title')}</h1>

          <div>
            <h2 className="font-semibold text-3xl">€{neo.pro.new_price}</h2>
            {neo.pro.old_price === null || reduction(neo.pro.old_price, neo.pro.new_price) === 0 ? null : (
              <div className="flex gap-2">
                <p className="text-lg font-normal line-through text-gray-600">€{neo.pro.old_price}</p>
                <p className="text-lg font-normal text-primary">
                  -{reduction(neo.pro.old_price, neo.pro.new_price)}% <span>{t('Percent')}</span>
                </p>
              </div>
            )}
            <p className="text-xs text-gray-600">{t('Vat')}</p>
          </div>
          
            {session?.user.is_superuser === true ? <div className='flex justify-end'> <AddReview userid={session?.user.id} productid={neo.pro.id}  color={selectcolor} size={selectsize} />   </div>: ""}
        
        
          <p className="text-sm p-4 bg-gray-100 text-gray-700">{t('Charity')}</p>
          {color.length > 0 && color[0].color !== "null" ? (
  <div> 
    <p className="font-semibold text-lg mb-4">{t('Color')}</p>
    <div className="flex gap-2 flex-wrap">
      {color.map((item: any) => (
        <div key={item.id} className='cursor-pointer'>
{selectcolor == item.color ?
        <p className="bg-gray-200 px-10 text-gray-600  border border-secondary py-2 flex items-center  " onClick={()=>setSelectColor(item.color)}> 
          {item.color}
        </p> :
<p className="bg-gray-200 px-10 text-gray-600 py-2 flex items-center" onClick={()=>setSelectColor(item.color)}> 
          {item.color}
        </p> 
      }  
      </div>
      ))}
    </div> 
  </div>
) : ""}
  
{size.length > 0 && size[0].size !== "null" ? (
    <div> 
         <div className='flex justify-between'>
            <p className="font-semibold text-lg  mb-4">{t('Size')}</p> 
          <SizeMeasurment/>
         </div>
        
          <div className="flex gap-2 flex-wrap">
            {size?.map((item:any) => (
              <div key={item.id} className='cursor-pointer'>
          {selectsize == item.size ?
        <p className="bg-gray-200 px-10 text-gray-600  border border-secondary py-2 flex items-center  " onClick={()=>setSelectsize(item.size)}> 
          {item.size}
        </p> :
<p className="bg-gray-200 px-10 text-gray-600 py-2 flex items-center" onClick={()=>setSelectsize(item.size)}> 
          {item.size}
        </p> 
      } 
              </div>
            ))}
          </div>
         

          </div>
) : ""}
          <div className="flex items-center gap-3 mt-4">
            <p className="font-semibold text-lg">{t('quantity')}</p>
            {num <= 1 ? (
              <FaMinusCircle size={18} className="text-gray-500 hover:text-black" />
            ) : (
              <FaMinusCircle onClick={Minus} size={18} className="text-gray-500 hover:text-black" />
            )}
            <span className="font-semibold leading-[18px] text-gray-500 select-none">{num}</span>
            <FaPlusCircle onClick={Plus} size={18} className="text-gray-500 hover:text-black" />
          </div>


{neo.pro.instock == "no" ? <p className='text-primary'>{t('instock')}</p> :

<div>
{color.length > 0 && color[0].color !== "null" && size.length > 0 && size[0].size !== "null" ?
  
 
  (selectsize == null || selectcolor == null? 
    <div>
    <p className='text-sm text-primary mb-1'>{t('select-color-size')} </p>
    <button className="w-full h-12 rounded-lg bg-secondary text-yel uppercase hover:bg-yel hover:text-secondary font-semibold">   
     {t('add to cart')}
</button>
 </div>
:
<button className="w-full h-12 rounded-lg bg-secondary text-yel uppercase hover:bg-yel hover:text-secondary font-semibold"
 onClick={()=>(add())}
 >
   {t('add to cart')}
 </button>

):
(size.length > 0 && size[0].size !== "null" ? 
    (selectsize == null ?
      <div>
      <p className='text-sm text-primary mb-1'> {t('select-size')} </p>
      <button className="w-full h-12 rounded-lg bg-secondary text-yel uppercase hover:bg-yel hover:text-secondary font-semibold">   
       {t('add to cart')}
</button>
   </div>
      :
      <button className="w-full h-12 rounded-lg bg-secondary text-yel uppercase hover:bg-yel hover:text-secondary font-semibold"
      onClick={()=>(add())}
   >
     {t('add to cart')}
   </button>
    ):
   (color.length > 0 && color[0].color !== "null" ? 

    (selectcolor == null ?
      <div>
         <p className='text-sm text-primary mb-1'> {t('select-color')} </p>
         <button className="w-full h-12 rounded-lg bg-secondary text-yel uppercase hover:bg-yel hover:text-secondary font-semibold">   
          {t('add to cart')}
   </button>
      </div>:
      <button className="w-full h-12 rounded-lg bg-secondary text-yel uppercase hover:bg-yel hover:text-secondary font-semibold"
      onClick={()=>(add())}
   >
     {t('add to cart')}
   </button>
    ):
   <button className="w-full h-12 rounded-lg bg-secondary text-yel uppercase hover:bg-yel hover:text-secondary font-semibold"
  onClick={()=>(add())}
   >
     {t('add to cart')}
   </button>)
  )}
{view ?
<div className='mt-1'>
  <Link href="/cart">
<button className="w-full h-12 rounded-lg bg-yel text-secondary uppercase hover:bg-secondary hover:text-yel font-semibold">
   {t('view-cart')}
   </button></Link>
</div>
 : ""
}

</div>      
}


          <ShippingDialog />
          <ReturnDialog />
          <SafeDialog />

         
          <DoubleAccordion content={parse(String(getLocalizedField(neo.pro, 'content')))} reviews={productReviews}/>
          <p className="text-sm text-gray-500 ">{t('share description')}</p>
         
         {social()}
        </div>
      </div>

<SuggestionsProducts p={neo.pro.id}/>
<Offer/>
<Newshop/>
    </div>
  );
}




const SkeletonLoader = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 custom:mx-52 animate-pulse">
      {/* Left Column - Image Section */}
      <div className="col-span-1">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-1">
          {/* Main Image Skeleton */}
          <div className="relative h-96 lg:h-[450px] custom:h-[600px] w-full bg-gray-200 rounded-lg"></div>
          {/* Optional Secondary Image Skeleton */}
          <div className="relative h-96 lg:h-[450px] custom:h-[600px] w-full bg-gray-200 rounded-lg"></div>
        </div>
      </div>

      {/* Right Column - Product Details Skeleton */}
      <div className="col-span-1 space-y-5 px-5 md:px-10">
        {/* Title Skeleton */}
        <div className="h-8 bg-gray-200 rounded w-3/4"></div>

        {/* Price Section Skeleton */}
        <div className="space-y-2">
          <div className="h-6 bg-gray-200 rounded w-1/2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/3"></div>
        </div>

        {/* Charity Message Skeleton */}
        <div className="h-12 bg-gray-200 rounded"></div>

        {/* Color Options Skeleton */}
        <div>
          <div className="h-6 bg-gray-200 rounded w-1/4 mb-4"></div>
          <div className="flex gap-2 flex-wrap">
            {[...Array(3)].map((_, index) => (
              <div key={index} className="h-8 bg-gray-200 rounded w-20"></div>
            ))}
          </div>
        </div>

        {/* Size Options Skeleton */}
        <div>
          <div className="h-6 bg-gray-200 rounded w-1/4 mb-4"></div>
          <div className="flex gap-2 flex-wrap">
            {[...Array(3)].map((_, index) => (
              <div key={index} className="h-8 bg-gray-200 rounded w-20"></div>
            ))}
          </div>
        </div>

        {/* Quantity Selector Skeleton */}
        <div className="flex items-center gap-3 mt-4">
          <div className="h-6 bg-gray-200 rounded w-1/4"></div>
          <div className="h-6 bg-gray-200 rounded w-6"></div>
          <div className="h-6 bg-gray-200 rounded w-6"></div>
        </div>

        {/* Add to Cart Button Skeleton */}
        <div className="h-12 bg-gray-200 rounded"></div>

        {/* Dialogs Skeleton */}
        <div className="space-y-4">
          <div className="h-12 bg-gray-200 rounded"></div>
          <div className="h-12 bg-gray-200 rounded"></div>
          <div className="h-12 bg-gray-200 rounded"></div>
        </div>

        {/* Accordion Skeleton */}
        <div className="space-y-2">
          <div className="h-8 bg-gray-200 rounded"></div>
          <div className="h-8 bg-gray-200 rounded"></div>
        </div>

        {/* Share Section Skeleton */}
        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        <div className="flex gap-3">
          {[...Array(8)].map((_, index) => (
            <div key={index} className="h-6 w-6 bg-gray-200 rounded-full"></div>
          ))}
        </div>
      </div>
    </div>
  );
};




